import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

function ContactBlock() {
  return (
    <div className="mt-8 space-y-8 md:mt-0">
      <div data-testid="footer-contact-address">
        <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#8FC4E8]">
          Alamat
        </p>
        <p className="mt-2 text-[15px] leading-relaxed text-white/90 md:text-base">
          Jl. Dr. Ir. H. Soekarno, 177, Surabaya, Jawa Timur 60117
        </p>
      </div>
      <div data-testid="footer-contact-phone">
        <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#8FC4E8]">
          Telepon
        </p>
        <a
          href="tel:+62315925418"
          data-testid="footer-contact-phone-link"
          className="mt-2 block text-[15px] text-white/90 transition-colors duration-300 hover:text-[#E8A33D] md:text-base"
        >
          Telp. (031) 5925418 atau (031) 5925419
        </a>
      </div>
      <div data-testid="footer-contact-email">
        <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#8FC4E8]">
          Email
        </p>
        <a
          href="mailto:ult.lldikti7@kemdiktisaintek.go.id"
          data-testid="footer-contact-email-link"
          className="mt-2 block break-all text-[15px] text-white/90 transition-colors duration-300 hover:text-[#E8A33D] md:text-base"
        >
          ult.lldikti7@kemdiktisaintek.go.id
        </a>
      </div>
    </div>
  );
}

function BottomBar() {
  return (
    <div className="flex flex-col justify-between gap-3 border-t border-white/15 px-6 py-6 text-[10px] font-medium tracking-[0.08em] text-white/60 md:flex-row md:items-center md:px-12 md:text-xs">
      <span data-testid="footer-copyright">
        © {new Date().getFullYear()} PPID - LLDIKTI Wilayah{" "}
        <Link
          to="/login"
          data-testid="footer-hidden-login"
          aria-label="Masuk"
          className="cursor-default text-inherit no-underline"
        >
          VII
        </Link>
      </span>
      <a
        data-testid="footer-external-link"
        href="https://lldikti7.kemdiktisaintek.go.id/"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-colors duration-300 hover:text-[#E8A33D]"
      >
        LLDIKTI7.KEMDIKTISAINTEK.GO.ID
      </a>
    </div>
  );
}

export default function Footer({ compact = false }) {
  if (compact) {
    return (
      <footer
        id="kontak"
        data-testid="footer"
        className="bg-[#0B2440] text-white"
      >
        <div className="grid items-center gap-8 px-6 py-10 md:grid-cols-[auto_1fr] md:gap-12 md:px-12">
          <div className="flex items-center gap-4">
            <img
              src="/logo.webp"
              alt="Logo Tut Wuri Handayani — Kemdiktisaintek"
              data-testid="footer-logo"
              className="h-12 w-12 object-contain"
            />
            <div>
              <p className="font-display text-xl font-semibold md:text-2xl">
                PPID{" "}
                <span className="font-normal text-[#8FC4E8]">- LLDIKTI VII</span>
              </p>
              <p className="mt-1 text-[11px] font-medium text-[#8FC4E8]">
                Pejabat Pengelola Informasi dan Dokumentasi
              </p>
            </div>
          </div>
          <ContactBlock />
        </div>
        <BottomBar />
      </footer>
    );
  }

  return (
    <footer id="kontak" data-testid="footer" className="bg-[#0B2440] text-white">
      <div className="grid gap-12 px-6 py-16 md:grid-cols-2 md:px-12 md:py-24">
        <Reveal>
          <img
            src="/logo.webp"
            alt="Logo Tut Wuri Handayani — Kemdiktisaintek"
            data-testid="footer-logo"
            className="h-16 w-16 object-contain"
          />
          <p className="mt-6 font-display text-3xl font-semibold md:text-4xl">
            PPID{" "}
            <span className="font-normal text-[#8FC4E8]">- LLDIKTI VII</span>
          </p>
          <p className="mt-3 text-sm font-medium text-[#8FC4E8]">
            Pejabat Pengelola Informasi dan Dokumentasi
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#8FC4E8]">
            Kontak
          </p>
          <ContactBlock />
        </Reveal>
      </div>
      <BottomBar />
    </footer>
  );
}
